export function getTranslationKey(...props: string[]): string {
  return props.join(".");
}

export const prettifyPickValue = (value: string = "") =>
  value
    .slice(3, value.length - 2)
    .split(".")
    .join(" / ");
